import React from 'react'
import { Modal, Table } from 'antd'
import './approverListModal.scss'

const ApproverListModal = ({ visible, onClose }) => {
  const dataSource = [
    {
      key: '1',
      category: 'Payroll and employee benefits',
      groupA: 'Kim Mulligan',
      groupB: 'Jing',
      groupAEmail: 'Kim.Mulligan@kmart.com.au',
      groupBEmail: 'jing.revilla@anko.com'
    },
    {
      key: '2',
      category: 'Employee engagement',
      groupA: 'Sedney',
      groupB: 'Jing',
      groupAEmail: 'sedney.besas@anko.com',
      groupBEmail: 'jing.revilla@anko.com'
    },
    {
      key: '3',
      category: 'Employee government remittances',
      groupA: 'Sedney',
      groupB: 'Jing',
      groupAEmail: 'sedney.besas@anko.com',
      groupBEmail: 'jing.revilla@anko.com'
    },
    {
      key: '4',
      category: 'Taxes, Licenses and Permits',
      groupA: 'Kim Mulligan',
      groupB: 'Jing',
      groupAEmail: 'Kim.Mulligan@kmart.com.au',
      groupBEmail: 'jing.revilla@anko.com'
    },
    {
      key: '5',
      category: 'Marketing',
      groupA: 'Kim Mulligan',
      groupB: 'Jing',
      groupAEmail: 'Kim.Mulligan@kmart.com.au',
      groupBEmail: 'jing.revilla@anko.com'
    },
    {
      key: '6',
      category: 'Store - Rent, security agency, IT and communications',
      groupA: 'Rachael Eames',
      groupB: 'Jing',
      groupAEmail: 'Rachael.Eames@kmart.com.au',
      groupBEmail: 'jing.revilla@anko.com'
    },
    {
      key: '7',
      category: 'Store - Office supplies',
      groupA: 'Rachael Eames',
      groupB: 'Jing',
      groupAEmail: 'Rachael.Eames@kmart.com.au',
      groupBEmail: 'jing.revilla@anko.com'
    },
    {
      key: '8',
      category: 'HO - Rent, security agency, IT and communications',
      groupA: 'Rachael Eames',
      groupB: 'Jing',
      groupAEmail: 'Rachael.Eames@kmart.com.au',
      groupBEmail: 'jing.revilla@anko.com'
    },
    {
      key: '9',
      category: 'HO - Office supplies',
      groupA: 'Rachael Eames',
      groupB: 'Jing',
      groupAEmail: 'Rachael.Eames@kmart.com.au',
      groupBEmail: 'jing.revilla@anko.com'
    },
    {
      key: '10',
      category: 'Professional fees, consultants',
      groupA: 'Kim Mulligan',
      groupB: 'Jing',
      groupAEmail: 'Kim.Mulligan@kmart.com.au',
      groupBEmail: 'jing.revilla@anko.com'
    },
    {
      key: '11',
      category: 'Inventory - FOB',
      groupA: 'Kim Mulligan',
      groupB: 'Jing',
      groupAEmail: 'Kim.Mulligan@kmart.com.au',
      groupBEmail: 'jing.revilla@anko.com'
    },
    {
      key: '12',
      category: 'Inventory - Shipping and duties',
      groupA: 'Kim Mulligan',
      groupB: 'Jing',
      groupAEmail: 'Kim.Mulligan@kmart.com.au',
      groupBEmail: 'jing.revilla@anko.com'
    },
    {
      key: '13',
      category: 'Warehouse',
      groupA: 'Kim Mulligan',
      groupB: 'Jing',
      groupAEmail: 'Kim.Mulligan@kmart.com.au',
      groupBEmail: 'jing.revilla@anko.com'
    },
    {
      key: '14',
      category: 'Employee reimbursements',
      groupA: 'Kim Mulligan',
      groupB: 'Jing',
      groupAEmail: 'Kim.Mulligan@kmart.com.au',
      groupBEmail: 'jing.revilla@anko.com'
    },
    {
      key: '15',
      category: 'Cash advances and liquidation',
      groupA: 'Kim Mulligan',
      groupB: 'Jing',
      groupAEmail: 'Kim.Mulligan@kmart.com.au',
      groupBEmail: 'jing.revilla@anko.com'
    },
    {
      key: '16',
      category: 'Store - Petty cash set up and replenishment',
      groupA: 'Rachael Eames',
      groupB: 'Jing',
      groupAEmail: 'Rachael.Eames@kmart.com.au',
      groupBEmail: 'jing.revilla@anko.com'
    },
    {
      key: '17',
      category: 'HO - Petty cash set up and replenishment',
      groupA: 'Kim Mulligan',
      groupB: 'Jing',
      groupAEmail: 'Kim.Mulligan@kmart.com.au',
      groupBEmail: 'jing.revilla@anko.com'
    },
    {
      key: '18',
      category: 'Store capex',
      groupA: 'Kim Mulligan',
      groupB: 'Jing',
      groupAEmail: 'Kim.Mulligan@kmart.com.au',
      groupBEmail: 'jing.revilla@anko.com'
    },
    {
      key: '19',
      category: 'HO capex',
      groupA: 'Kim Mulligan',
      groupB: 'Jing',
      groupAEmail: 'Kim.Mulligan@kmart.com.au',
      groupBEmail: 'jing.revilla@anko.com'
    },
     {
      key: '20',
      category: 'Store - Change Fund set up',
      groupA: 'Rachael Eames',
      groupB: 'Jing',
      groupAEmail: 'Rachael.Eames@kmart.com.au',
      groupBEmail: 'jing.revilla@anko.com'
    }
  ]

  const columns = [
    {
      title: 'Categories',
      dataIndex: 'category',
      key: 'category',
      width: '40%',
      className: 'category-column'
    },
    {
      title: 'Kmart Approver',
      key: 'groupA',
      width: '30%',
      className: 'group-column',
      render: (_, record) => (
        <div className="approver-cell">
          <div className="approver-name">{record.groupA}</div>
          <div className="approver-email">{record.groupAEmail}</div>
        </div>
      )
    },
    {
      title: 'Ayala Approver',
      key: 'groupB',
      width: '30%',
      className: 'group-column',
      render: (_, record) => (
        <div className="approver-cell">
          <div className="approver-name">{record.groupB}</div>
          <div className="approver-email">{record.groupBEmail}</div>
        </div>
      )
    }
  ]

  return (
    <Modal
      title="Approvers of Request for Payments"
      open={visible}
      onCancel={onClose}
      footer={null}
      width={800}
      className="approver-list-modal"
    >
      <Table
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        bordered
        size="middle"
        className="approver-table"
        scroll={{ y: 400 }}
      />
    </Modal>
  )
}

export default ApproverListModal
